export default "__VITE_ASSET__CrZ9eLof__"